import React from "react";
import { ThunmbsUpIcon, ThumbsDownIcon, BookMarkIcon } from "../images/Icons";
import "../styles/VideoPlayerLikeDislike.css";

const VideoPlayerLikeDislike = () => {
  return (
    <div className="videoplayer-like-dislike-container">
      <ThunmbsUpIcon />
      <ThumbsDownIcon />
      <BookMarkIcon />
    </div>
  );
};

export default VideoPlayerLikeDislike;
